module.exports = __webpack_public_path__ + "static/media/danpatkim68.cbac91d8.png";